module.exports = __webpack_public_path__ + "img/SuperOK-blue-pink.9742cb5d.jpg";